import { createPropertySelectors } from '@ngxs/store'
import { CorrelationDataState, CorrelationDataStateModel } from './correlation-data.state'

export class CorrelationDataStateSelectors {
  static slices = createPropertySelectors<CorrelationDataStateModel>(CorrelationDataState)
}
